import React from 'react';
import './Home.css';

function Home() {
  return (
    <section className="hero">
      <div className="hero-bg" />
      <div className="hero-lines" />
      <div className="hero-content">
        <p className="hero-eyebrow">Maryland&#8202;&bull;&#8202;Live Music</p>
        <h1 className="hero-title">Mike <em>Mallick</em></h1>
        <p className="hero-tagline">Smooth &bull; Soul &bull; Rock</p>
        <div className="hero-video">
          <iframe
            src="https://www.youtube.com/embed/HBQhYWrJNqo?rel=0&modestbranding=1"
            title="Mike Mallick — Feeling All Right"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}

export default Home;
